export default class FulfillmentUser {
    attendCode = null;
    code = '';
    _name = '';
    get name() {
        return String(this._name);
    }
    set name(value) {
        this._name = String(value);
    }
    phoneNumber = '';
    geoWorkerDistance = '';
    constructor(data) {
        Object.assign(this, data);
    }
}
